import React from 'react'
import { cn } from '@utils'
import { InputType } from '@constants'
import { useSessionStore } from '@stores'

import StepLabel from '@/components/steps/StepLabel'

interface StepTitleProps {
  children?: React.ReactNode
  subtitle?: React.ReactNode
  content?: React.ReactNode
  product?: React.ReactNode
  staticData?: React.ReactNode
  session?: any
  hr?: boolean
  className?: string
}

const StepTitle = ({
  children,
  subtitle,
  content,
  product,
  staticData,
  session: sessionProp,
  hr = false,
  className,
}: StepTitleProps) => {
  const storeSession = useSessionStore(state => state.session)
  // In a popup the live step is popupSession; callers pass it so gating (image,
  // selected product, title class) reflects the popup, not the background step.
  const session = sessionProp ?? storeSession
  const isSessionUserKnown = useSessionStore(state => state.isSessionUserKnown)
  const currentSelectedItem = useSessionStore(state => state.currentSelectedItem)

  const titleClass =
    isSessionUserKnown() && (session as any)?.step_type === InputType.Confirmation ? 'welcome-label' : 'title'

  const hasProduct = !!product
  const hasTitle = !!children
  const hasSubtitle = !!subtitle
  const hasContent = !!content
  const hasStaticData = !!staticData && !!(session as any)?.step_static_data

  const selectedItem = currentSelectedItem?.()
  const hasSelectedProduct = !!(session as any)?.show_selected_product && !!selectedItem

  const renderWithFontSizing = (value: React.ReactNode, cls?: string) => {
    if (typeof value === 'string') {
      return <StepLabel content={value} className={cls} />
    }
    return <div className={cls}>{value}</div>
  }

  return (
    <section
      className={cn(
        'step-intro',
        { steps_spacing: session && !session.is_legacy },
        !(session as any)?.enhanced_mode && 'product-selection-normal',
        hasSelectedProduct && 'mt-0',
        className
      )}>
      <div className="flex flex-wrap">
        <div className="flex-1">
          {hasProduct && (
            <div className="product-container-top">
              <div className="product">{product}</div>
            </div>
          )}

          {hasTitle && <h2 className={titleClass}>{renderWithFontSizing(children)}</h2>}

          {hasSubtitle && <div className="subtitle">{renderWithFontSizing(subtitle)}</div>}

          {hasProduct && (
            <div className="product-container-middle">
              <div className="product">{product}</div>
            </div>
          )}

          {hr && <hr />}

          {hasContent && (
            <div className={cn('content', 'content-width', { 'app-content': session && !session.is_legacy })}>
              {renderWithFontSizing(content)}
            </div>
          )}

          {hasStaticData && <div>{staticData}</div>}
        </div>
      </div>
    </section>
  )
}

export default StepTitle
